(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["viva-discovery"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('viva-studio')) customElements.define('viva-studio', class extends HTMLElement {
  connectedCallback() {
    if (this.abort) return;
    this.track = this.querySelector('.viva-studio__track');
    if (!this.track) return;
    this.abort = new AbortController();
    const options = { signal: this.abort.signal };
    this.slides = [...this.track.children];
    this.buttons = [...this.querySelectorAll('[data-studio-to]')];
    this.toggle = this.querySelector('[data-studio-toggle]');
    this.motion = matchMedia('(prefers-reduced-motion: reduce)');
    this.duration = Math.max(4000, Number(this.dataset.interval) || 6000);
    this.paused = this.dataset.autoplay === 'false' || this.motion.matches || Boolean(window.Shopify?.designMode);
    this.visible = false;
    this.hovered = false;
    this.touching = false;
    this.moving = false;
    this.animations = new Set();
    this.index = 0;
    this.update();
    this.settledIndex = this.index;
    this.querySelector('.viva-studio__navigation').hidden = this.slides.length < 2;
    this.buttons.forEach((button, index) => button.addEventListener('click', () => this.go(index), options));
    this.querySelector('[data-studio-prev]').addEventListener('click', () => this.go(this.index - 1), options);
    this.querySelector('[data-studio-next]').addEventListener('click', () => this.go(this.index + 1), options);
    this.toggle.addEventListener('click', () => {
      this.paused = !this.paused;
      this.syncClock();
    }, options);
    this.addEventListener('pointerenter', event => {
      if (event.pointerType !== 'mouse') return;
      this.hovered = true;
      this.syncClock();
    }, options);
    this.addEventListener('pointerleave', event => {
      if (event.pointerType !== 'mouse') return;
      this.hovered = false;
      this.syncClock();
    }, options);
    this.addEventListener('focusin', event => {
      if (event.target === this.toggle) return;
      this.paused = true;
      this.syncClock();
    }, options);
    this.track.addEventListener('pointerdown', () => {
      this.touching = true;
      this.syncClock();
    }, options);
    const release = () => {
      if (!this.touching) return;
      this.touching = false;
      this.syncClock();
    };
    window.addEventListener('pointerup', release, options);
    window.addEventListener('pointercancel', release, options);
    this.track.addEventListener('scroll', () => {
      this.moving = true;
      this.stopClock();
      cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => this.update());
      clearTimeout(this.settleTimer);
      this.settleTimer = setTimeout(() => this.settle(), 160);
    }, { ...options, passive: true });
    this.track.addEventListener('scrollend', () => this.settle(), options);
    this.track.addEventListener('keydown', event => {
      if (event.target !== this.track || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      this.go(event.key === 'Home' ? 0 : event.key === 'End' ? this.slides.length - 1 : this.index + (event.key === 'ArrowRight' ? 1 : -1));
    }, options);
    document.addEventListener('visibilitychange', () => this.syncClock(), options);
    this.motion.addEventListener('change', () => {
      if (this.motion.matches) {
        this.paused = true;
        this.animations.forEach(animation => animation.cancel());
        this.animations.clear();
        this.track.scrollTo({ left: this.index * this.track.clientWidth, behavior: 'instant' });
      }
      this.syncClock();
    }, options);
    this.resize = new ResizeObserver(() => {
      this.track.scrollTo({ left: this.index * this.track.clientWidth, behavior: 'instant' });
      this.settle();
    });
    this.resize.observe(this.track);
    this.observer = new IntersectionObserver(entries => {
      this.visible = entries[0].isIntersecting;
      this.syncClock();
    }, { threshold: 0 });
    this.observer.observe(this);
    this.syncClock();
  }
  update() {
    if (!this.track.clientWidth) return;
    this.index = Math.max(0, Math.min(this.slides.length - 1, Math.round(this.track.scrollLeft / this.track.clientWidth)));
    this.buttons.forEach((button, index) => button.setAttribute('aria-current', String(index === this.index)));
    this.slides.forEach((slide, index) => { slide.inert = index !== this.index; });
  }
  go(index) {
    this.stopClock();
    index = (index + this.slides.length) % this.slides.length;
    const left = index * this.track.clientWidth;
    this.moving = true;
    this.track.scrollTo({ left, behavior: this.motion.matches ? 'instant' : 'smooth' });
    // A click on the current slide does not emit a scroll event.
    if (Math.abs(this.track.scrollLeft - left) < 1) this.settle();
  }
  settle() {
    clearTimeout(this.settleTimer);
    this.update();
    if (this.index !== this.settledIndex && !this.motion.matches) {
      this.animations.forEach(animation => animation.cancel());
      this.animations.clear();
      this.slides[this.index].querySelectorAll('.vx-campaign-foot > div').forEach(element => {
        const animation = element.animate([
          { opacity: 0.75, transform: 'translateY(10px)' },
          { opacity: 1, transform: 'translateY(0)' }
        ], { duration: 450, easing: 'cubic-bezier(.22,1,.36,1)' });
        this.animations.add(animation);
        animation.finished.then(() => this.animations.delete(animation)).catch(() => {});
      });
    }
    this.settledIndex = this.index;
    this.moving = false;
    this.syncClock();
  }
  stopClock() {
    clearTimeout(this.timer);
    this.progress?.cancel();
    this.progress = null;
    this.dataset.studioRunning = 'false';
  }
  syncClock() {
    this.stopClock();
    this.dataset.studioPlaying = String(!this.paused);
    this.toggle.setAttribute('aria-label', this.paused ? this.toggle.dataset.playLabel : this.toggle.dataset.pauseLabel);
    if (this.paused || this.hovered || this.touching || this.moving || !this.visible || document.hidden || this.slides.length < 2) return;
    this.dataset.studioRunning = 'true';
    const indicator = this.buttons[this.index].querySelector('.viva-studio__progress');
    if (!this.motion.matches) this.progress = indicator.animate([
      { transform: 'scaleX(0)' }, { transform: 'scaleX(1)' }
    ], { duration: this.duration, fill: 'forwards' });
    this.timer = setTimeout(() => this.go(this.index + 1), this.duration);
  }
  disconnectedCallback() {
    this.stopClock();
    clearTimeout(this.settleTimer);
    cancelAnimationFrame(this.frame);
    this.abort?.abort();
    this.abort = null;
    this.resize?.disconnect();
    this.observer?.disconnect();
    this.animations?.forEach(animation => animation.cancel());
  }
});

if(!customElements.get('viva-departments'))customElements.define('viva-departments',class extends HTMLElement{
connectedCallback(){if(this.motionAbort)return;this.motionAbort=new AbortController();this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.animations=new Set();this.motion.addEventListener('change',()=>{if(this.motion.matches){this.observer?.disconnect();this.animations.forEach(a=>a.cancel());this.animations.clear();}},{signal:this.motionAbort.signal});if(this.motion.matches||!('IntersectionObserver' in window)||!Element.prototype.animate)return;this.observer=new IntersectionObserver(entries=>{entries.filter(e=>e.isIntersecting).sort((a,b)=>a.target.compareDocumentPosition(b.target)&Node.DOCUMENT_POSITION_FOLLOWING?-1:1).forEach((entry,i)=>{this.observer.unobserve(entry.target);if(this.motion.matches)return;const animation=entry.target.animate([{opacity:.55,transform:'translateY(16px)'},{opacity:1,transform:'translateY(0)'}],{duration:600,delay:Math.min(i,3)*60,easing:'cubic-bezier(.22,1,.36,1)',fill:'backwards'});this.animations.add(animation);animation.finished.then(()=>this.animations.delete(animation)).catch(()=>{});});},{threshold:.15});this.querySelectorAll('[data-dept-reveal]').forEach(item=>this.observer.observe(item));}
disconnectedCallback(){this.motionAbort?.abort();this.motionAbort=null;this.observer?.disconnect();this.animations?.forEach(a=>a.cancel());}
});

  } catch(e) { console.error(e); }
})();
})();
